module.exports = __webpack_public_path__ + "img/orange_bg.ce7d3603.png";